import { render, staticRenderFns } from "./Rec.vue?vue&type=template&id=7060ad54&"
import script from "./Rec.vue?vue&type=script&lang=js&"
export * from "./Rec.vue?vue&type=script&lang=js&"
import style0 from "./Rec.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7060ad54')) {
      api.createRecord('7060ad54', component.options)
    } else {
      api.reload('7060ad54', component.options)
    }
    module.hot.accept("./Rec.vue?vue&type=template&id=7060ad54&", function () {
      api.rerender('7060ad54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/detail/components/Rec.vue"
export default component.exports